import { render } from "./EditCollectionModal.vue?vue&type=template&id=594cafab&scoped=true"
import script from "./EditCollectionModal.vue?vue&type=script&lang=js"
export * from "./EditCollectionModal.vue?vue&type=script&lang=js"

import "./EditCollectionModal.vue?vue&type=style&index=0&id=594cafab&lang=stylus&scoped=true"
import "./EditCollectionModal.vue?vue&type=style&index=1&id=594cafab&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594cafab"]])

export default __exports__